import "./Inbox.css";

export default function Inbox({ emails, selectedEmailId, onSelectEmail }) {
  if (!emails || emails.length === 0) {
    return (
      <div className="inbox-empty">
        <div className="inbox-empty-icon" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v11a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5z" />
            <path d="M4 13h4l2 3h4l2-3h4" />
          </svg>
        </div>
        <div className="inbox-empty-text">წერილები არ მოიძებნა</div>
        <div className="inbox-empty-hint">ახალი წერილები ავტომატურად გამოჩნდება</div>
      </div>
    );
  }

  return (
    <div className="inbox-container">
      <div className="inbox-list">
        {emails.map((email) => (
          <div
            key={email.id}
            className={`inbox-item ${selectedEmailId === email.id ? "active" : ""} ${!email.is_read ? "unread" : ""}`}
            onClick={() => onSelectEmail(email)}
          >
            {!email.is_read && <span className="unread-dot" />}
            <div className="inbox-item-header">
              <span className="inbox-from">{email.from_email}</span>
              <span className="inbox-date">
                {new Date(email.processed_at).toLocaleDateString("ka-GE")}
              </span>
            </div>
            <div className="inbox-subject">{email.subject}</div>
            <div className="inbox-badges">
              {email.urgency && (
                <span className={`urgency-tag ${email.urgency}`}>{email.urgency}</span>
              )}
              {email.department_names?.length > 1
                ? email.department_names.map((name) => (
                    <span key={name} className="dept-tag">{name}</span>
                  ))
                : email.department_name && (
                    <span className="dept-tag">{email.department_name}</span>
                  )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
